import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";
import { TEMPERATURES } from "./pipeline";

const DOT = { cold: "bg-sky-500", warm: "bg-amber-500", hot: "bg-rose-500" };

// Temperature as a colour dot only (grid-dense). Click to change; the title carries the word.
export function TempDot({ value, onChange, testId, optionTestId }) {
  const meta = TEMPERATURES.find((t) => t.value === value);
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger title={meta ? `${meta.label} — change temperature` : "Set temperature"} data-testid={testId}
        className="h-6 w-6 justify-center rounded-md border-0 bg-transparent p-0 shadow-none hover:bg-slate-100 focus:ring-0 [&>svg]:hidden">
        <span className={`block h-3 w-3 rounded-full ${meta ? DOT[value] : "border-2 border-dashed border-slate-300"}`} />
      </SelectTrigger>
      <SelectContent>
        {TEMPERATURES.map((t) => (
          <SelectItem key={t.value} value={t.value} data-testid={optionTestId ? optionTestId(t.value) : undefined}>
            <span className="inline-flex items-center gap-2"><span className={`h-2.5 w-2.5 rounded-full ${DOT[t.value]}`} />{t.label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
